/** Validation and fetch limits shared across the organizations feature. */
export const ORGANIZATION_NAME_MIN_LENGTH = 2;
export const ORGANIZATION_NAME_MAX_LENGTH = 80;
export const MONOBANK_TOKEN_MIN_LENGTH = 8;
export const OWNER_SEARCH_DEBOUNCE_MS = 300;
export const ORGANIZATIONS_SEARCH_DEBOUNCE_MS = 300;
export const OWNER_SEARCH_PAGE_SIZE = 10;
export const ORGANIZATIONS_LIST_PAGE_SIZE = 100;
